import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const streamRegFields = [
  "gaming_ContactId", // Lookup - contact
  "gaming_CompanyId", // Lookup - company
  "gaming_userentitlementdata", // Choice
  "gaming_companyname", // Text
  "gaming_firstname", // Text
  "gaming_lastname", // Text
  "gaming_emailaddress", // Text
  "gaming_streamregid", // UID
  "gaming_companyrole", // Text
  "gaming_licensedgamepublishers", // Multiselect
  "gaming_submitteddateutc", // Date
  "gaming_entitlementdatatermsaccepted", // Choice
  "gaming_entitlementdatatermsaccepteddateutc", // Date
  "gaming_registrationnumber",
  "gaming_emailaddressverified", // Boolean
] as const;

export const streamRegReferences: EntityReferences<EntityName.gaming_streamreg> = {
  [EntityName.contact]: ["gaming_ContactId"],
};

export const streamRegKey: AnyEntityField<EntityName.gaming_streamreg> = "gaming_streamregid";
